export default __webpack_public_path__ + "static/media/Animations_Bar13.e20b1c7e.svg";